<section class="preview business-card-preview" *ngIf="visible">
  <ion-segment [value]="selectedSide" (ionChange)="selectedSideChange.emit($any($event.detail.value))">
    <ion-segment-button value="front">Front Side</ion-segment-button>
    <ion-segment-button value="back">Back Side</ion-segment-button>
  </ion-segment>

  <app-business-card-renderer
    [textSections]="textSections"
    [logoSections]="logoSections"
    [qrCodes]="qrCodes"
    [qrImages]="qrImages"
    [backgroundStyle]="backgroundStyle"
    [showGrid]="showGrid"
    [gridStyle]="gridStyle"
    [elementStyle]="elementStyle"
    [qrElementId]="qrElementId"
    [showLogoRemove]="true"
    (editText)="editText.emit($event)"
    (dragStart)="dragStart.emit($event)"
    (dragMove)="dragMove.emit($event)"
    (dragStop)="dragStop.emit($event)"
    (removeLogo)="removeLogo.emit($event)"
  ></app-business-card-renderer>
</section>
